<template>
  <div class="pagina ativa" id="paginaBi">
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;border-bottom:2px solid #4a5c2f;padding-bottom:10px;">
      <div style="display:flex;align-items:center;gap:8px;font-size:22px;font-weight:bold;color:#4a5c2f;"><LineChart :size="22" /> Análise BI</div>
      <div style="display:flex;gap:8px;">
        <button @click="salvarVisaoAtual" style="display:inline-flex;align-items:center;gap:5px;margin:0;padding:8px 16px;font-size:13px;background:#27ae60;"><Save :size="14" /> Salvar Visão</button>
        <button @click="carregarDados" style="display:inline-flex;align-items:center;gap:5px;margin:0;padding:8px 16px;font-size:13px;"><RotateCcw :size="14" /> Atualizar Dados</button>
      </div>
    </div>

    <div class="bi-painel" style="padding:14px 20px;">
      <div style="font-size:13px;font-weight:bold;color:#4a5c2f;margin-bottom:6px;">Como usar o BI Explorer</div>
      <div style="font-size:12px;color:#555;line-height:1.7;margin-bottom:12px;background:#f8f9f6;border-radius:8px;padding:10px 14px;">
        <b>Tabela Dinâmica:</b> Agrupe as vendas por qualquer dimensão (Vendedor, BEM, Mês, etc.) nas linhas e colunas, escolha a métrica (Qtd, Valor, Ticket, Comissão, Canceladas) e clique em Gerar. Use os filtros de Período, Vendedor e BEM para recortar os dados.<br>
        <b>Gráfico Livre:</b> Escolha o eixo X (ex: Mês), o eixo Y (ex: Valor Total), o agrupamento (ex: por BEM) e o tipo de gráfico. Ideal para visualizar tendências e comparações visuais.<br>
        <b>Comparativo:</b> Selecione dois períodos (Mês/Ano) e compare lado a lado — vê variação de valor e quantidade com seta de tendência.<br>
        <b>Meta vs Realizado:</b> Veja o quanto cada vendedor (ou BEM/Tabela) atingiu da meta no mês selecionado. As metas vêm da tela de Metas.<br>
        <b>Salvar Visão:</b> Salva a configuração atual dos filtros e dimensões para recarregar com um clique depois.
      </div>
      <div style="font-size:12px;color:#888;margin-bottom:6px;">Visões Salvas:</div>
      <div class="bi-visoes">
        <span v-if="visoes.length === 0" style="color:#aaa;font-size:12px;">Nenhuma visão salva.</span>
        <div v-for="v in visoes" :key="v.nome" class="bi-visao-chip" @click="carregarVisao(v)">
          <span>{{ v.nome }}</span>
          <span @click.stop="excluirVisao(v.nome)" style="display:inline-flex;color:#c0392b;cursor:pointer;margin-left:4px;"><X :size="12" /></span>
        </div>
      </div>
    </div>

    <div class="bi-tabs">
      <div class="bi-tab" :class="{ ativo: abaAtual === 'dinamica' }" @click="abaAtual = 'dinamica'" style="display:flex;align-items:center;gap:6px;"><BarChart3 :size="14" /> Tabela Dinâmica</div>
      <div class="bi-tab" :class="{ ativo: abaAtual === 'grafico' }" @click="abaAtual = 'grafico'; $nextTick(gerarGrafico)" style="display:flex;align-items:center;gap:6px;"><LineChart :size="14" /> Gráfico Livre</div>
      <div class="bi-tab" :class="{ ativo: abaAtual === 'comparativo' }" @click="abaAtual = 'comparativo'" style="display:flex;align-items:center;gap:6px;"><Shuffle :size="14" /> Comparativo</div>
      <div class="bi-tab" :class="{ ativo: abaAtual === 'metareal' }" @click="abaAtual = 'metareal'" style="display:flex;align-items:center;gap:6px;"><Target :size="14" /> Meta vs Realizado</div>
    </div>

    <!-- ABA TABELA DINAMICA -->
    <div v-show="abaAtual === 'dinamica'">
      <div class="bi-painel">
        <div class="bi-titulo-painel" style="display:flex;align-items:center;gap:7px;"><BarChart3 :size="15" /> Configure a Tabela Dinâmica</div>
        <div class="bi-row">
          <div class="bi-group"><span class="bi-label">Linhas</span>
            <select v-model="dinamica.linha">
              <option value="vendedor">Vendedor</option><option value="bem">BEM</option><option value="tabela">Tabela</option>
              <option value="mes">Mês</option><option value="trimestre">Trimestre</option><option value="ano">Ano</option><option value="status">Status</option>
            </select>
          </div>
          <div class="bi-group"><span class="bi-label">Colunas</span>
            <select v-model="dinamica.coluna">
              <option value="nenhuma">— Nenhuma —</option><option value="bem">BEM</option><option value="vendedor">Vendedor</option>
              <option value="mes">Mês</option><option value="trimestre">Trimestre</option><option value="ano">Ano</option><option value="status">Status</option>
            </select>
          </div>
          <div class="bi-group"><span class="bi-label">Valor</span>
            <select v-model="dinamica.metrica">
              <option value="qtd">Qtd Vendas</option><option value="valor">Valor Total (R$)</option><option value="ticket">Ticket Médio (R$)</option>
              <option value="comissao">Comissão (R$)</option><option value="canceladas">Canceladas/Estornadas</option><option value="txcanc">Taxa Cancelamento (%)</option>
            </select>
          </div>
          <div class="bi-group"><span class="bi-label">Filtro Período</span>
            <select v-model="filtros.periodo"><option value="">Todos</option><option v-for="p in periodos" :key="p" :value="p">{{ p }}</option></select>
          </div>
          <div class="bi-group"><span class="bi-label">Filtro Vendedor</span>
            <select v-model="filtros.vendedor"><option value="">Todos</option><option v-for="v in vendedoresLista" :key="v" :value="v">{{ v }}</option></select>
          </div>
          <div class="bi-group"><span class="bi-label">Filtro BEM</span>
            <select v-model="filtros.bem">
              <option value="">Todos</option><option value="AUTOMOVEL">Automóvel</option><option value="IMOVEIS">Imóveis</option>
              <option value="PESADOS">Pesados</option><option value="SERVICO E MOTO">Serviço/Moto</option><option value="IMOVEL ESTENDIDO">Imóvel Estendido</option>
            </select>
          </div>
          <button class="bi-btn" @click="gerarTabelaDinamica">Gerar</button>
        </div>
        <div class="bi-result" v-html="resultDinamica || '<p style=\'color:#aaa;text-align:center;padding:30px;\'>Configure os campos e clique em Gerar.</p>'"></div>
      </div>
    </div>

    <!-- ABA GRAFICO -->
    <div v-show="abaAtual === 'grafico'">
      <div class="bi-painel">
        <div class="bi-titulo-painel" style="display:flex;align-items:center;gap:7px;"><LineChart :size="15" /> Configure o Gráfico</div>
        <div class="bi-row">
          <div class="bi-group"><span class="bi-label">Eixo X (dimensão)</span>
            <select v-model="grafico.x">
              <option value="mes">Mês</option><option value="vendedor">Vendedor</option><option value="bem">BEM</option>
              <option value="tabela">Tabela</option><option value="trimestre">Trimestre</option><option value="status">Status</option>
            </select>
          </div>
          <div class="bi-group"><span class="bi-label">Eixo Y (métrica)</span>
            <select v-model="grafico.y">
              <option value="valor">Valor Total</option><option value="qtd">Qtd Vendas</option><option value="ticket">Ticket Médio</option>
              <option value="comissao">Comissão</option><option value="txcanc">Taxa Cancelação %</option>
            </select>
          </div>
          <div class="bi-group"><span class="bi-label">Agrupar por</span>
            <select v-model="grafico.grupo">
              <option value="nenhuma">— Nenhum —</option><option value="bem">BEM</option><option value="vendedor">Vendedor</option><option value="status">Status</option>
            </select>
          </div>
          <div class="bi-group"><span class="bi-label">Tipo Gráfico</span>
            <select v-model="grafico.tipo">
              <option value="bar">Barras</option><option value="line">Linha</option><option value="doughnut">Pizza</option><option value="radar">Radar</option>
            </select>
          </div>
          <div class="bi-group"><span class="bi-label">Período</span>
            <select v-model="grafico.periodo"><option value="">Todos</option><option v-for="p in periodos" :key="p" :value="p">{{ p }}</option></select>
          </div>
          <button class="bi-btn" @click="gerarGrafico">Gerar</button>
        </div>
        <div style="max-height:400px;"><canvas ref="canvasGrafico"></canvas></div>
      </div>
    </div>

    <!-- ABA COMPARATIVO -->
    <div v-show="abaAtual === 'comparativo'">
      <div class="bi-painel">
        <div class="bi-titulo-painel" style="display:flex;align-items:center;gap:7px;"><Shuffle :size="15" /> Comparativo de Períodos</div>
        <div class="bi-row">
          <div class="bi-group"><span class="bi-label">Período A</span>
            <select v-model="comparativo.a"><option value="">Selecione...</option><option v-for="p in periodos" :key="p" :value="p">{{ p }}</option></select>
          </div>
          <div class="bi-group"><span class="bi-label">Período B</span>
            <select v-model="comparativo.b"><option value="">Selecione...</option><option v-for="p in periodos" :key="p" :value="p">{{ p }}</option></select>
          </div>
          <div class="bi-group"><span class="bi-label">Dimensão</span>
            <select v-model="comparativo.dim">
              <option value="total">Total Geral</option><option value="vendedor">Por Vendedor</option><option value="bem">Por BEM</option>
            </select>
          </div>
          <button class="bi-btn" @click="gerarComparativo">Comparar</button>
        </div>
        <div v-html="resultComparativo"></div>
      </div>
    </div>

    <!-- ABA META vs REALIZADO -->
    <div v-show="abaAtual === 'metareal'">
      <div class="bi-painel">
        <div class="bi-titulo-painel" style="display:flex;align-items:center;gap:7px;"><Target :size="15" /> Meta vs Realizado Detalhado</div>
        <div class="bi-row">
          <div class="bi-group"><span class="bi-label">Mês</span>
            <select v-model="metareal.mes">
              <option v-for="m in meses" :key="m.v" :value="m.v">{{ m.l }}</option>
            </select>
          </div>
          <div class="bi-group"><span class="bi-label">Ano</span>
            <select v-model="metareal.ano"><option value="2025">2025</option><option value="2026">2026</option><option value="2027">2027</option></select>
          </div>
          <div class="bi-group"><span class="bi-label">Visão</span>
            <select v-model="metareal.visao">
              <option value="vendedor">Por Vendedor</option><option value="bem">Por BEM</option><option value="tabela">Por Tabela</option>
            </select>
          </div>
          <button class="bi-btn" @click="gerarMetaRealizado">Gerar</button>
        </div>
        <div v-html="resultMeta"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPost, apiDelete } from '../api'
import { LineChart, Save, RotateCcw, X, BarChart3, Shuffle, Target } from 'lucide-vue-next'

export default {
  name: 'PaginaBi',
  components: { LineChart, Save, RotateCcw, X, BarChart3, Shuffle, Target },
  data() {
    const hj = new Date()
    return {
      dados: null,
      visoes: [],
      abaAtual: 'dinamica',
      dinamica: { linha: 'vendedor', coluna: 'nenhuma', metrica: 'qtd' },
      filtros: { periodo: '', vendedor: '', bem: '' },
      grafico: { x: 'mes', y: 'valor', grupo: 'nenhuma', tipo: 'bar', periodo: '' },
      comparativo: { a: '', b: '', dim: 'total' },
      metareal: { mes: String(hj.getMonth() + 1).padStart(2, '0'), ano: String(hj.getFullYear()), visao: 'vendedor' },
      meses: [
        { v: '01', l: 'Jan' }, { v: '02', l: 'Fev' }, { v: '03', l: 'Mar' }, { v: '04', l: 'Abr' },
        { v: '05', l: 'Mai' }, { v: '06', l: 'Jun' }, { v: '07', l: 'Jul' }, { v: '08', l: 'Ago' },
        { v: '09', l: 'Set' }, { v: '10', l: 'Out' }, { v: '11', l: 'Nov' }, { v: '12', l: 'Dez' }
      ],
      resultDinamica: '',
      resultComparativo: '',
      resultMeta: '',
      graficoInstance: null
    }
  },
  computed: {
    vendas() { return this.dados ? this.dados.vendas : [] },
    periodos() {
      const s = new Set(this.vendas.map(v => v.mes))
      return [...s].sort().reverse()
    },
    vendedoresLista() {
      const s = new Set(this.vendas.map(v => v.vendedor).filter(Boolean))
      return [...s].sort()
    }
  },
  created() {
    this.carregarDados()
  },
  methods: {
    async carregarDados() {
      this.resultDinamica = '<p style="color:#aaa;text-align:center;padding:20px;">Carregando dados...</p>'
      const [rd, rv] = await Promise.all([apiGet('bi/dados'), apiGet('config/bi-visoes/listar')])
      if (rd.sucesso) this.dados = rd
      if (rv.sucesso) this.visoes = rv.visoes
      this.resultDinamica = ''
    },
    filtrarDados() {
      let d = this.vendas
      if (this.filtros.periodo) d = d.filter(v => v.mes === this.filtros.periodo)
      if (this.filtros.vendedor) d = d.filter(v => v.vendedor === this.filtros.vendedor)
      if (this.filtros.bem) d = d.filter(v => v.bem === this.filtros.bem)
      return d
    },
    agregar(dados, dimLinha, dimColuna, metrica) {
      const mapa = {}
      const colSet = {}
      dados.forEach(v => {
        if (v.isFilha && metrica !== 'canceladas' && metrica !== 'txcanc') return
        const linha = v[dimLinha] || '—'
        const col = dimColuna && dimColuna !== 'nenhuma' ? (v[dimColuna] || '—') : '_total_'
        if (!mapa[linha]) mapa[linha] = {}
        if (!mapa[linha][col]) mapa[linha][col] = { qtd: 0, valor: 0, comissao: 0, canceladas: 0, total: 0 }
        mapa[linha][col].qtd += (v.isFilha ? 0 : 1)
        mapa[linha][col].valor += v.valor
        mapa[linha][col].comissao += v.comissao
        mapa[linha][col].canceladas += v.cancelada
        mapa[linha][col].total += (v.isFilha ? 0 : 1)
        colSet[col] = true
      })
      return { mapa, cols: Object.keys(colSet).sort() }
    },
    extrairValor(cell, metrica) {
      if (!cell) return 0
      if (metrica === 'qtd') return cell.qtd
      if (metrica === 'valor') return cell.valor
      if (metrica === 'ticket') return cell.qtd > 0 ? cell.valor / cell.qtd : 0
      if (metrica === 'comissao') return cell.comissao
      if (metrica === 'canceladas') return cell.canceladas
      if (metrica === 'txcanc') return cell.total > 0 ? (cell.canceladas / cell.total * 100) : 0
      return 0
    },
    formatar(v, metrica) {
      if (metrica === 'valor' || metrica === 'comissao' || metrica === 'ticket') return 'R$ ' + v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      if (metrica === 'txcanc') return v.toFixed(1) + '%'
      return Math.round(v).toLocaleString('pt-BR')
    },
    gerarTabelaDinamica() {
      if (!this.dados) { this.carregarDados(); return }
      const { linha: dimLinha, coluna: dimColuna, metrica } = this.dinamica
      const dados = this.filtrarDados()
      const { mapa, cols } = this.agregar(dados, dimLinha, dimColuna, metrica)
      const linhas = Object.keys(mapa).sort()
      const temColunas = dimColuna !== 'nenhuma' && cols.length > 0

      let html = '<table class="bi-table"><thead><tr><th>' + dimLinha.charAt(0).toUpperCase() + dimLinha.slice(1) + '</th>'
      if (temColunas) { cols.forEach(c => { html += '<th>' + c + '</th>' }); html += '<th class="total-col">Total</th>' } else { html += '<th>' + metrica + '</th>' }
      html += '</tr></thead><tbody>'

      const totCols = {}
      linhas.forEach(linha => {
        html += '<tr><td style="font-weight:bold;">' + linha + '</td>'
        let totLinha = 0
        if (temColunas) {
          cols.forEach(col => {
            const v = this.extrairValor(mapa[linha][col], metrica)
            totLinha += v
            if (!totCols[col]) totCols[col] = 0
            totCols[col] += v
            html += '<td>' + this.formatar(v, metrica) + '</td>'
          })
          html += '<td class="total-col">' + this.formatar(totLinha, metrica) + '</td>'
        } else {
          const v2 = this.extrairValor(mapa[linha]['_total_'], metrica)
          html += '<td>' + this.formatar(v2, metrica) + '</td>'
        }
        html += '</tr>'
      })

      if (temColunas && linhas.length > 1) {
        html += '<tr class="total-row"><td>TOTAL</td>'
        let gtot = 0
        cols.forEach(col => { const v = totCols[col] || 0; gtot += v; html += '<td>' + this.formatar(v, metrica) + '</td>' })
        html += '<td>' + this.formatar(gtot, metrica) + '</td></tr>'
      }

      html += '</tbody></table>'
      this.resultDinamica = html
    },
    gerarGrafico() {
      if (!this.dados) { this.carregarDados(); return }
      if (typeof window.Chart === 'undefined' || !this.$refs.canvasGrafico) return
      const Chart = window.Chart
      const { x: dimX, y: metricaY, grupo, tipo, periodo } = this.grafico
      let dados = this.vendas
      if (periodo) dados = dados.filter(v => v.mes === periodo)

      const CORES = ['#4a5c2f', '#27ae60', '#f39c12', '#3498db', '#8e44ad', '#e74c3c', '#16a085', '#d35400']

      if (this.graficoInstance) { this.graficoInstance.destroy(); this.graficoInstance = null }
      const ctx = this.$refs.canvasGrafico.getContext('2d')

      if (grupo === 'nenhuma') {
        const agg = {}
        dados.forEach(v => {
          if (v.isFilha) return
          const k = v[dimX] || '—'
          if (!agg[k]) agg[k] = { qtd: 0, valor: 0, comissao: 0, canceladas: 0, total: 0 }
          agg[k].qtd++; agg[k].valor += v.valor; agg[k].comissao += v.comissao; agg[k].canceladas += v.cancelada; agg[k].total++
        })
        const labels = Object.keys(agg).sort()
        const valores = labels.map(k => {
          const c = agg[k]
          if (metricaY === 'qtd') return c.qtd
          if (metricaY === 'valor') return c.valor
          if (metricaY === 'ticket') return c.qtd > 0 ? c.valor / c.qtd : 0
          if (metricaY === 'comissao') return c.comissao
          if (metricaY === 'txcanc') return c.total > 0 ? c.canceladas / c.total * 100 : 0
          return 0
        })
        this.graficoInstance = new Chart(ctx, {
          type: tipo,
          data: { labels, datasets: [{ label: metricaY, data: valores, backgroundColor: tipo === 'line' ? 'rgba(74,92,47,0.1)' : CORES, borderColor: tipo === 'line' ? '#4a5c2f' : CORES, borderWidth: tipo === 'line' ? 2 : 0, fill: tipo === 'line', tension: 0.3, borderRadius: tipo === 'bar' ? 5 : 0 }] },
          options: { responsive: true, plugins: { legend: { display: tipo !== 'bar' } }, scales: (tipo === 'doughnut' || tipo === 'radar') ? {} : { y: { beginAtZero: true } } }
        })
      } else {
        const grupos = [...new Set(dados.filter(v => !v.isFilha).map(v => v[grupo] || '—'))].sort()
        const eixos = [...new Set(dados.filter(v => !v.isFilha).map(v => v[dimX] || '—'))].sort()
        const datasets = grupos.map((g, gi) => {
          const vals = eixos.map(x => {
            const sub = dados.filter(v => !v.isFilha && (v[grupo] || '—') === g && (v[dimX] || '—') === x)
            if (!sub.length) return 0
            const qtd = sub.length
            const val = sub.reduce((s, v) => s + v.valor, 0)
            const com = sub.reduce((s, v) => s + v.comissao, 0)
            const canc = sub.reduce((s, v) => s + v.cancelada, 0)
            if (metricaY === 'qtd') return qtd
            if (metricaY === 'valor') return val
            if (metricaY === 'ticket') return qtd > 0 ? val / qtd : 0
            if (metricaY === 'comissao') return com
            if (metricaY === 'txcanc') return qtd > 0 ? canc / qtd * 100 : 0
            return 0
          })
          return { label: g, data: vals, backgroundColor: CORES[gi % CORES.length] + '99', borderColor: CORES[gi % CORES.length], borderWidth: 2, borderRadius: tipo === 'bar' ? 5 : 0, fill: false, tension: 0.3 }
        })
        this.graficoInstance = new Chart(ctx, {
          type: tipo === 'doughnut' ? 'bar' : tipo,
          data: { labels: eixos, datasets },
          options: { responsive: true, plugins: { legend: { display: true } }, scales: { y: { beginAtZero: true } } }
        })
      }
    },
    gerarComparativo() {
      if (!this.dados) { this.carregarDados(); return }
      const { a: pA, b: pB, dim } = this.comparativo
      if (!pA || !pB) { alert('Selecione os dois períodos.'); return }
      const dadosA = this.vendas.filter(v => v.mes === pA && !v.isFilha)
      const dadosB = this.vendas.filter(v => v.mes === pB && !v.isFilha)

      const agregar = (arr) => {
        const m = {}
        arr.forEach(v => {
          const k = dim === 'total' ? 'Total' : (v[dim] || '—')
          if (!m[k]) m[k] = { qtd: 0, valor: 0, comissao: 0, canceladas: 0 }
          m[k].qtd++; m[k].valor += v.valor; m[k].comissao += v.comissao; m[k].canceladas += v.cancelada
        })
        return m
      }
      const mA = agregar(dadosA)
      const mB = agregar(dadosB)
      const chaves = [...new Set([...Object.keys(mA), ...Object.keys(mB)])].sort()

      const delta = (a, b) => {
        if (b === 0) return { txt: '—', cls: 'neu' }
        const p = ((a - b) / b * 100).toFixed(1)
        return { txt: (a >= b ? '▲' : '▼') + Math.abs(p) + '%', cls: a >= b ? 'pos' : 'neg' }
      }
      const fmtV = v => 'R$ ' + v.toLocaleString('pt-BR', { minimumFractionDigits: 2 })

      let html = '<div style="overflow-x:auto;"><table class="bi-table"><thead><tr>' +
        '<th>' + dim.charAt(0).toUpperCase() + dim.slice(1) + '</th>' +
        '<th colspan="3">' + pA + '</th>' +
        '<th colspan="3">' + pB + '</th>' +
        '<th>Δ Valor</th><th>Δ Qtd</th>' +
        '</tr><tr>' +
        '<th></th><th>Qtd</th><th>Valor</th><th>Ticket</th>' +
        '<th>Qtd</th><th>Valor</th><th>Ticket</th>' +
        '<th></th><th></th></tr></thead><tbody>'

      const tA = { qtd: 0, val: 0 }
      const tB = { qtd: 0, val: 0 }
      chaves.forEach(k => {
        const a = mA[k] || { qtd: 0, valor: 0, comissao: 0 }
        const b = mB[k] || { qtd: 0, valor: 0, comissao: 0 }
        const dV = delta(a.valor, b.valor)
        const dQ = delta(a.qtd, b.qtd)
        tA.qtd += a.qtd; tA.val += a.valor; tB.qtd += b.qtd; tB.val += b.valor
        html += '<tr><td style="font-weight:bold;">' + k + '</td>' +
          '<td>' + a.qtd + '</td><td>' + fmtV(a.valor) + '</td><td>' + (a.qtd > 0 ? fmtV(a.valor / a.qtd) : '—') + '</td>' +
          '<td>' + b.qtd + '</td><td>' + fmtV(b.valor) + '</td><td>' + (b.qtd > 0 ? fmtV(b.valor / b.qtd) : '—') + '</td>' +
          '<td><span class="bi-delta ' + dV.cls + '">' + dV.txt + '</span></td>' +
          '<td><span class="bi-delta ' + dQ.cls + '">' + dQ.txt + '</span></td>' +
          '</tr>'
      })

      const dTV = delta(tA.val, tB.val)
      const dTQ = delta(tA.qtd, tB.qtd)
      html += '<tr class="total-row"><td>TOTAL</td>' +
        '<td>' + tA.qtd + '</td><td>' + fmtV(tA.val) + '</td><td>' + (tA.qtd > 0 ? fmtV(tA.val / tA.qtd) : '—') + '</td>' +
        '<td>' + tB.qtd + '</td><td>' + fmtV(tB.val) + '</td><td>' + (tB.qtd > 0 ? fmtV(tB.val / tB.qtd) : '—') + '</td>' +
        '<td><span class="bi-delta ' + dTV.cls + '">' + dTV.txt + '</span></td>' +
        '<td><span class="bi-delta ' + dTQ.cls + '">' + dTQ.txt + '</span></td>' +
        '</tr></tbody></table></div>'

      this.resultComparativo = html
    },
    gerarMetaRealizado() {
      if (!this.dados) { this.carregarDados(); return }
      const { mes, ano, visao } = this.metareal
      const mesAno = ano + '-' + mes
      const dados = this.vendas.filter(v => v.mes === mesAno && !v.isFilha)
      const metas = this.dados.metas || []

      const metaGeral = metas.filter(m => m.mes === parseInt(mes) && m.ano === parseInt(ano) && m.tipo === 'geral')
      const metaVendedor = metas.filter(m => m.mes === parseInt(mes) && m.ano === parseInt(ano) && m.tipo === 'vendedor')
      const mgv = metaGeral.length > 0 ? metaGeral[metaGeral.length - 1].meta : 0

      const agg = {}
      dados.forEach(v => {
        const k = v[visao] || '—'
        if (!agg[k]) agg[k] = { qtd: 0, valor: 0, comissao: 0, canceladas: 0 }
        agg[k].qtd++; agg[k].valor += v.valor; agg[k].comissao += v.comissao; agg[k].canceladas += v.cancelada
      })

      const totalReal = Object.values(agg).reduce((s, v) => s + v.valor, 0)
      const pctGeral = mgv > 0 ? Math.min(totalReal / mgv * 100, 999) : 0
      const cG = pctGeral >= 100 ? '#27ae60' : pctGeral >= 70 ? '#f39c12' : '#e74c3c'

      let html = ''
      if (mgv > 0) {
        html += '<div class="bi-painel" style="margin-bottom:12px;">' +
          '<div class="bi-titulo-painel">Meta Geral — ' + mes + '/' + ano + '</div>' +
          '<div style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px;margin-bottom:12px;">' +
          '<div class="card"><div class="card-label">Meta</div><div class="card-valor">R$ ' + mgv.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) + '</div></div>' +
          '<div class="card"><div class="card-label">Realizado</div><div class="card-valor" style="color:#4a5c2f;">R$ ' + totalReal.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) + '</div></div>' +
          '<div class="card"><div class="card-label">Falta</div><div class="card-valor" style="color:' + cG + ';">R$ ' + Math.max(mgv - totalReal, 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) + '</div></div>' +
          '</div>' +
          '<div style="background:#eee;border-radius:10px;height:20px;overflow:hidden;">' +
          '<div style="background:' + cG + ';height:100%;width:' + Math.min(pctGeral, 100) + '%;border-radius:10px;display:flex;align-items:center;justify-content:center;">' +
          '<span style="color:white;font-size:12px;font-weight:bold;">' + pctGeral.toFixed(1) + '%</span>' +
          '</div>' +
          '</div>' +
          '</div>'
      }

      const chaves = Object.keys(agg).sort()
      html += '<table class="bi-table"><thead><tr><th>' + visao.charAt(0).toUpperCase() + visao.slice(1) + '</th><th>Qtd</th><th>Realizado</th><th>Ticket Médio</th><th>Comissão</th><th>Canceladas</th>' +
        (visao === 'vendedor' ? '<th>Meta</th><th>% Atingido</th><th>Progresso</th>' : '') + '</tr></thead><tbody>'

      chaves.forEach(k => {
        const a = agg[k]
        let metaV = 0
        if (visao === 'vendedor') {
          const mv = metaVendedor.filter(m => m.vendedor === k || (m.vendedor || '').toUpperCase() === 'TODOS')
          if (mv.length > 0) metaV = mv[mv.length - 1].meta
        }
        const pct = metaV > 0 ? (a.valor / metaV * 100) : 0
        const cV = pct >= 100 ? '#27ae60' : pct >= 70 ? '#f39c12' : '#e74c3c'
        html += '<tr><td style="font-weight:bold;">' + k + '</td>' +
          '<td>' + a.qtd + '</td>' +
          '<td>R$ ' + a.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) + '</td>' +
          '<td>R$ ' + (a.qtd > 0 ? (a.valor / a.qtd).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : '—') + '</td>' +
          '<td>R$ ' + a.comissao.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) + '</td>' +
          '<td style="color:#c0392b;">' + a.canceladas + '</td>' +
          (visao === 'vendedor'
            ? '<td>' + (metaV > 0 ? 'R$ ' + metaV.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : '—') + '</td>' +
              '<td><span style="font-weight:bold;color:' + cV + ';">' + (metaV > 0 ? pct.toFixed(1) + '%' : '—') + '</span></td>' +
              '<td style="min-width:100px;">' + (metaV > 0 ? '<div style="background:#eee;border-radius:6px;height:10px;"><div style="background:' + cV + ';height:100%;width:' + Math.min(pct, 100) + '%;border-radius:6px;"></div></div>' : '—') + '</td>'
            : '') +
          '</tr>'
      })

      html += '</tbody></table>'
      this.resultMeta = html
    },
    async salvarVisaoAtual() {
      const nome = prompt('Nome para esta visão:')
      if (!nome || !nome.trim()) return
      const config = {
        aba: this.abaAtual,
        dinamica: { linha: this.dinamica.linha, coluna: this.dinamica.coluna, metrica: this.dinamica.metrica },
        grafico: { x: this.grafico.x, y: this.grafico.y, grupo: this.grafico.grupo, tipo: this.grafico.tipo },
        comparativo: { dim: this.comparativo.dim },
        metareal: { visao: this.metareal.visao }
      }
      await apiPost('config/bi-visoes/salvar', { nome: nome.trim(), config: JSON.stringify(config) })
      const rv = await apiGet('config/bi-visoes/listar')
      if (rv.sucesso) this.visoes = rv.visoes
      alert('Visão "' + nome + '" salva!')
    },
    carregarVisao(v) {
      let c
      try { c = JSON.parse(v.config) } catch (e) { return }
      if (c.dinamica) {
        this.dinamica.linha = c.dinamica.linha || 'vendedor'
        this.dinamica.coluna = c.dinamica.coluna || 'nenhuma'
        this.dinamica.metrica = c.dinamica.metrica || 'qtd'
      }
      if (c.grafico) {
        this.grafico.x = c.grafico.x || 'mes'
        this.grafico.y = c.grafico.y || 'valor'
        this.grafico.grupo = c.grafico.grupo || 'nenhuma'
        this.grafico.tipo = c.grafico.tipo || 'bar'
      }
      if (c.comparativo) this.comparativo.dim = c.comparativo.dim || 'total'
      if (c.metareal) this.metareal.visao = c.metareal.visao || 'vendedor'
      this.abaAtual = c.aba || 'dinamica'
      this.$nextTick(() => {
        if (c.aba === 'dinamica') this.gerarTabelaDinamica()
        else if (c.aba === 'grafico') this.gerarGrafico()
        else if (c.aba === 'comparativo') this.gerarComparativo()
        else if (c.aba === 'metareal') this.gerarMetaRealizado()
      })
    },
    async excluirVisao(nome) {
      if (!confirm('Excluir visão "' + nome + '"?')) return
      await apiDelete('config/bi-visoes/excluir', { nome })
      const rv = await apiGet('config/bi-visoes/listar')
      if (rv.sucesso) this.visoes = rv.visoes
    }
  }
}
</script>
